const ACTIVE_CLASS = 'modal--active'
const body = document.body;
const input = document.querySelector("#modal");
const modal = document.querySelector(".modal-wrapper");
const container = document.querySelector(".modal-content");
let scrollY = 0

const triggers = document.querySelectorAll("[data-modal-trigger]");

function close() {
    console.log('close')
    const checked = input.getAttribute('checked')

    if (!checked) {
        return;
    }

    container.innerHTML = ''

    input.removeAttribute('checked')
    body.classList.remove(ACTIVE_CLASS)
    window.scrollTo({ top: scrollY, behavior: 'smooth' })
}

function open(content = false) {
    scrollY = window.scrollY
    const checked = input.getAttribute('checked')

    if (checked) {
        return;
    }

    if (content) {
        container.innerHTML = content.outerHTML
    }

    input.setAttribute('checked', 'checked')
    body.classList.add(ACTIVE_CLASS)
}

function toggle(content = false) {
    const checked = input.getAttribute('checked')

    if (checked) {
        close()
    } else {
        open(content)
    }
}

function setup() {
    // input.addEventListener('change', toggle)
    modal.addEventListener('click', (e) => {
        e.stopPropagation()
        close();
    })

    triggers.forEach(trigger => {
        const id = trigger.dataset.modalTrigger
        const content = document.querySelector(`[data-modal-content="${id}"]`)

        if (content) {
            const clone = content.cloneNode(true)
            clone.removeAttribute('data-modal-content')

            trigger.addEventListener('click', () => {
                open(clone)
            })
        } else {
            console.warn(`The trigger "${id}" doesn't have any matching content. The modal will not open.`)
        }
    })
}

function init() {
    if (!input || !modal || !container) {
        console.warn("Modal configured incorrectly.");
        return;
    }

    setup()
}

init();
